<template></template>

<script>
export default {};
</script>

<style lang="scss">
.WordPress {
	overflow-x: auto;

	/* Use serif typeface */
	p,
	ol,
	ul {
		font-family: $default-font-family;
	}
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	button,
	table,
	figure,
	.wp-caption {
		font-family: $default-font-family;
	}

	h1 {
		@include h1--thin;
	}

	h2 {
		@include h2--thin;
	}

	/* Let subcontainers overflow as well */
	p,
	span {
		overflow-x: inherit;
	}

	/* Underline all links in wp content */
	a:not(.Button) {
		@include link($color-link, $underline: true);
	}

	/* Make long links break */
	a {
		overflow-wrap: break-word;
		word-wrap: break-word;
	}

	/* Style overrides for all media */
	figure,
	iframe,
	picture,
	video {
		max-width: 100%;
		margin: 0 auto $space-md;
	}

	// don't override media feed styles
	figure.MediaFeed-item {
		margin: 0 $space-md $space-md 0;
		[dir='rtl'] & {
			margin: 0 0 $space-md $space-md;
		}
	}

	// WP media alignment classes
	.alignnone,
	.aligncenter,
	.alignleft,
	.alignright {
		clear: both;
		display: block;
		margin: 0 auto $space-lg;
		max-width: 100%;
	}

	@include breakpoint(medium) {
		// Only float if not on an small device
		.alignleft {
			float: left;
			margin: 0 $space-lg $space-lg 0;
			[dir='rtl'] & {
				float: right;
				margin: 0 0 $space-lg $space-lg;
			}
			clear: both;
			max-width: 60% !important;
		}
		.alignright {
			float: right;
			margin: 0 0 $space-lg $space-lg;
			[dir='rtl'] & {
				float: left;
				margin: 0 $space-lg $space-lg 0;
			}
			clear: both;
			max-width: 60% !important;
		}
	}

	/* When a caption is present, add margin to the image */
	.wp-caption {
		max-width: 100%;
		img {
			@include stack-sm;
		}
		.wp-caption-text {
			color: $color-text-muted;
			font-size: $text-size-sm;
			margin: 0;
		}
	}
}
</style>
